<template>
  <div id="app">
    <topheader
      :key="timer"
      v-show="
        !(path == '/forget' || path == '/login' || path == '/examination')
      "
    ></topheader>
    <router-view />
    <r-footer
      v-show="
        !(
          path == '/forget' ||
          path == '/myTask' ||
          path == '/login' ||
          path == '/examination' ||
          path == '/taskOrder' ||
          path == '/taskHall' ||
          path == '/recruitList'
        )
      "
    ></r-footer>
  </div>
</template>
<script>
import topheader from "./components/header.vue";
import footer from "./components/realFooter.vue";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: { topheader, "r-footer": footer },
  data() {
    return {
      timer: null,
      path: null,
    };
  },
  methods: {
    handleHead() {
      this.timer = new Date().getTime();
    },
  },
  watch: {
    $route(to) {
      this.path = to.path;
    },
  },
  // beforeCreate() {
  //   //beforeCreate()，created(), beforeMount(), mounted() 都可以
  //   console.log('app beforeCreate',this.$route.path);
  //   if (this.$route.path == '/') {
  //     this.$router.replace('/result')
  //   }
  // },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.path = this.$route.path;
    this.$EventBts.$on("handleHead", () => {
      this.handleHead();
    });
  },
  beforeDestroy() {
    this.$EventBts.$off("handleHead");
  }, //生命周期 - 销毁之前
};
</script>
<style lang="scss">
html {
  overflow-y: scroll;
}
</style>
